import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';

@Injectable({ providedIn: 'root' })
export class RateCardService {
  public url = '/api/ratecard';

  constructor(public http: HttpClient) {}

  public get(customerid: number, supplierid: number, hourstypeid: number): Promise<any[]> {
    return this.http
      .get(`${this.url}/${customerid}/${supplierid}/${hourstypeid}`)
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }

  public save(
    customerid: number,
    supplierid: number,
    hourstypeid: number,
    serviceid: number,
    pricing: any,
  ): Promise<any> {
    return this.http
      .post(`${this.url}/${customerid}/${supplierid}/${hourstypeid}/${serviceid}`, pricing)
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }

  public changeIsServiceOffered(
    customerid: number,
    supplierid: number,
    serviceid: number,
    isServiceOffered: boolean,
  ) {
    return this.http
      .post(
        `${this.url}/changeserviceoffered/${customerid}/${supplierid}/${serviceid}/${isServiceOffered}`,
        null,
      )
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }

  public extractData(res) {
    return res;
  }

  public handleError(errorResponse: HttpErrorResponse | any) {
    let fullErrorMessage: string;
    if (errorResponse instanceof HttpErrorResponse) {
      const error = errorResponse.error || JSON.stringify(errorResponse);
      fullErrorMessage = `${errorResponse.status} - ${errorResponse.statusText || ''} ${error}`;
    } else {
      fullErrorMessage = errorResponse.message ? errorResponse.message : errorResponse.toString();
    }
    console.error(fullErrorMessage);
    return Promise.reject(fullErrorMessage);
  }
}
